import moment from 'moment'

export function makeEventData (event) {
  let data = {
    title: event.title,
    description: event.description,
    event_type: event.event_type,
    all_day: !event.start_time,
    in_attendance: !!event.in_attendance_staff, // As discussed, this field will be used for staff only. For students, if required, we will add in the db manually.
    weekend: !!event.weekend,

    start_date: moment(event.start_date),
    start_time: event.start_time ? moment(event.start_time, 'hh:mm:ss') : '',
    end_date: event.end_date ? moment(event.end_date) : '',
    end_time: event.end_time ? moment(event.end_time, 'hh:mm:ss') : '',

    session_id: event.session_id,
    class_id: event.class_id ? event.class_id : 0,
    section_id: event.section_id ? event.section_id : 0,

    target_audience: event.target_audience,
    notification_date_time: event.send_notification ? moment(event.notification_date_time) : undefined,
  }

  if (!event.end_date) {
    delete data.end_date
  }
  if (!event.start_time) {
    delete data.start_time
  }
  if (!event.end_time) {
    delete data.end_time
  }

  return data
}
